var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.manager.textTags && _vm.manager.textTags.length)?_c('div',{staticClass:"d-flex align-center w100",class:{
		'justify-center': _vm.manager.alignment == 'center',
		'justify-end': _vm.manager.alignment == 'right',
	}},_vm._l((_vm.manager.textTags),function(ref,n){
	var text = ref.text;
return _c('div',{key:n,staticClass:"product-card__text-tag font-0 line-clamp-1 px-1 error rounded"},[_vm._v(" "+_vm._s(text)+" ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }